import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Reveal } from "../components/Reveal";
import { LEGAL_PAGES } from "../data/legal";

export default function LegalPage({ slug }) {
    const page = LEGAL_PAGES[slug];

    useEffect(() => {
        document.title = `${page.title} | PISI LIMITED`;
        window.scrollTo(0, 0);
    }, [page.title]);

    return (
        <div data-testid={`legal-page-${slug}`}>
            <Navbar />
            <main className="bg-white pt-[72px]">
                <div className="mx-auto max-w-3xl px-5 py-16 sm:px-8 lg:py-20">
                    <Reveal>
                        <Link
                            to="/"
                            data-testid="legal-back-link"
                            className="inline-flex items-center gap-2 text-sm font-medium text-slate-500 transition-colors hover:text-navy-900"
                        >
                            <ArrowLeft className="h-4 w-4" />
                            Back to Home
                        </Link>
                        <h1 className="mt-8 font-heading text-3xl font-bold tracking-tight text-navy-900 sm:text-4xl">
                            {page.title}
                        </h1>
                        <p className="mt-3 text-xs font-medium uppercase tracking-[0.16em] text-slate-400">
                            {page.updated}
                        </p>
                        <p className="mt-6 border-l-2 border-gold pl-5 text-base leading-relaxed text-slate-600">
                            {page.intro}
                        </p>
                        <div className="mt-4 divide-y divide-slate-100">
                            {page.sections.map((section, i) => (
                                <section key={section.heading} className="py-8">
                                    <h2 className="font-heading text-lg font-semibold text-navy-900">
                                        {i + 1}. {section.heading}
                                    </h2>
                                    <p className="mt-3 text-sm leading-relaxed text-slate-600 sm:text-base">
                                        {section.body}
                                    </p>
                                </section>
                            ))}
                        </div>
                    </Reveal>
                </div>
            </main>
            <Footer />
        </div>
    );
}
